import Spinner from '@service-victoria/component-library/components/Icons/Spinner';
import List from '@service-victoria/component-library/components/List';
import Text from '@service-victoria/component-library/components/Text';
import React from 'react';

import LinkButton from 'Components/LinkButton';
import useModal from 'hooks/useModal';
import PrivacyModal from 'services/contentService/PrivacyModal';

import { CenterAlign } from './styled';

type ModalFailedProps = {
  privacyModal: PrivacyModal;
};

export const ModalFailed: React.FC<ModalFailedProps> = ({ privacyModal }) => {
  const modal = useModal();

  return (
    <div>
      <Text.Body>
        Please{' '}
        <LinkButton
          onClick={() => {
            modal.open(privacyModal.getDetails, {
              loader: (
                <CenterAlign>
                  <Spinner />
                </CenterAlign>
              )
            });
          }}
          primary>
          click here
        </LinkButton>{' '}
        to try again.
      </Text.Body>
      <Text.Body>What might be causing this:</Text.Body>
      <List
        type='disc'
        items={[
          'no network connectivity',
          'a browser plugin blocking the data',
          'poor network coverage where you are'
        ]}
      />
    </div>
  );
};
export default ModalFailed;
